<template>
  <div ref="animationChart" :class="graphHeightClass" />
</template>

<script lang="ts">
import { defineComponent, onMounted, Ref, ref, toRefs, computed } from 'vue';
import lottie from 'lottie-web';
import { scriptOnReady } from '@cpc/lib-js-require';

import { PROD_LOTTIE_SDK_JS_LINK } from '../constants';
// import type { AnimationItem } from 'lottie-web';

export default defineComponent({
  name: 'DynamicGraph',
  props: {
    lottieJson: {
      type: String,
      default: '',
    },
    isFullHeight: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const { isFullHeight, lottieJson } = toRefs(props);

    const animationChart: Ref<Element | null> = ref(null);

    let animation: any;

    onMounted(() => {
      if (lottie) {
        initNoCommentAni();
      } else {
        scriptOnReady({
          url: window.pageData?.lottieSdkUrl || PROD_LOTTIE_SDK_JS_LINK,
          namespace: 'lottie',
          callback: () => {
            initNoCommentAni();
          },
        });
      }
    });

    const graphHeightClass = computed(() => {
      return isFullHeight.value ? 'full-height' : 'default-height';
    });

    const initNoCommentAni = () => {
      animation?.destroy();
      animation = (lottie).loadAnimation({
        container: animationChart.value,
        renderer: 'svg',
        loop: false,
        autoplay: true,
        path: lottieJson.value,
      });
      animation.play();
    };

    document.addEventListener('nightmodechange', initNoCommentAni);

    return {
      graphHeightClass,
      animationChart,
    };
  },
});
</script>

<style lang="scss" scoped>
.default-height {
  height: 360px;
}
.full-height {
  height: 600px;
}
</style>
